import request from '@/utils/request'

export function commCode(cmmCdGrpId) {
    let params = {
        cmmCdGrpId: cmmCdGrpId
    }
    return request({
        url: `/ococ/datacapture/v1/commonCodes`,
        method: 'get',
        params
    })
}

export function retrieveDateList(type) {
    let dateList = []
    let date = ""
    if(type === "year") {
        let currentYear = new Date().getFullYear()
        for(let i=0; i<10; i++) {
            date = currentYear+i
            dateList.push(date.toString())
        }
    }

    if(type === "month") {
        for(let i=0; i<12; i++) {
            date = i+1
            if(date < 10) date = "0" + date.toString()
            else date = date.toString()
            dateList.push(date)
        }
    }
    return dateList
}

export function callAuthPopup(){
    return new Promise((resolve,reject)=>{

        window.cbAuthPop = (res) =>{
            resolve(res)
        }
        let url = '/after-activation/auth-popup'
        window.open(url,"authPopup","width=450,height=550,top=100,left=100,fullscreen=no,menubar=no,status=no,toolbar=no,titlebar=yes,location=no,scrollbar=no")
    })

}
// 커텍티드카 사용
export function callKmcAuthPopup(ifameShow) {
    return new Promise((resolve, reject) => {
        window.cbAuthPop = (res) => {
            resolve(res)
        }
        if (!ifameShow) {
            let url = '/auth-popup/kmc-auth-popup'
            window.open(url, "authPopup", "width=450,height=550,top=100,left=100,fullscreen=no,menubar=no,status=no,toolbar=no,titlebar=yes,location=no,scrollbar=no")
        }

    })
}

// 공인인증 오픈마켓사용
export function callNormalPopup(reqData) {
    return new Promise((resolve,reject)=>{
        window.cbAuthPop = (res) =>{
            resolve(res)
        }

            window.normalauthdata = {
                custNm: reqData.custNm,
                custPersId: reqData.custPersId,
                onetMblAppfNo: reqData.onetMblAppfNo,
                pymnDivsCd: reqData.pymnDivsCd
            }
            let url = '/auth-popup/normal-auth-popup'
            window.open(url,"authPopup","width=450,height=550,top=100,left=100,fullscreen=no,menubar=no,status=no,toolbar=no,titlebar=yes,location=no,scrollbar=no")

        
    })
}
// 커텍티드카 사용
export function callIpinPopup(ifameShow) {
    return new Promise((resolve, reject) => {
        window.cbAuthPop = (res) => {
            resolve(res)
        }
        if (!ifameShow) {
            let url = '/auth-popup/ipin-auth-popup'
            window.open(url, "authPopup", "width=450,height=550,top=100,left=100,fullscreen=no,menubar=no,status=no,toolbar=no,titlebar=yes,location=no,scrollbar=no")
        }

    })
}

export function searchAddr(inAddr) {
    let params = {
        inAddr: inAddr
    }
    return request({
        url: `/ococ/registration/v1/toss/ZpcdAddrSrch`,
        method: 'get',
        params
    })
}

// 모바일 인증
export function smsAuthSend(reqData) {
    let mobileInfo = {
        phoneNo: reqData.phoneNo,
        dealCd: reqData.dealCd,
        onetMblAppfNo: reqData.onetMblAppfNo,
        buyer: reqData.lgdBuyer,
        birthDay: reqData.lgdPrivateno
    }
    return request({
        url: `/ococ/datacapture/auth/smsAuthSend`,
        method: 'post',
        data: mobileInfo
    })
}

// 커넥티드카 모바일 인증
export function smsAuthSendConnctedCar(reqData) {
    let mobileInfo = {
        phoneNo: reqData.phoneNo,
        dealCd: reqData.dealCd,
        onetMblAppfNo: reqData.onetMblAppfNo,
        buyer: reqData.lgdBuyer,
        birthDay: reqData.lgdPrivateno
    }
    return request({
        url: `/ococ/datacapture/auth/smsAuthSendConnctedCar`,
        method: 'post',
        data: mobileInfo
    })
}

// 모바일인증 결과체크 페이지
export function smsAuthCheck(reqData) {
    let mobileAuthInfo =  {
        no: reqData.phoneNo,
        dealCd: reqData.dealCd,
        onetMblAppfNo: reqData.onetMblAppfNo,
        custName: reqData.lgdBuyer,
        juminNo: reqData.lgdPrivateno,
        smsval: reqData.smsval,
        tradeid: reqData.tradeid
    }
    return request({
        url: `/ococ/datacapture/auth/smsAuthCheck`,
        method: 'post',
        data: mobileAuthInfo
    })
}

// 요금제 조회
export function getSelfPhonePay(reqData) {
    let params = {
        aplcTlno: reqData.aplcTlno
    }
    return request({
        url: `/ococ/datacapture/openmarket/getSelfPhonePay`,
        method: 'get',
        params
    })
}
// 단말기 모델 조회
export function getDiviceModelInfo(reqData) {
    let params = {
        dealCd: reqData.dealCd,
        entrRqstFomNo: reqData.entrRqstFomNo
    }
    return request({
        url: `/ococ/datacapture/openmarket/getDiviceModelInfo`,
        method: 'get',
        params
    })
}

export function updateMobileActivationAfterEntr(reqData) {
    return request({
        url: `/ococ/activation/v1/mobileAppfs/afterEntrRqst`,
        method: 'put',
        data: reqData
    })
}
// KMC 인증 모듈 호출
export function getKmcDetailEncrypt(reqData) {
    return request({
        url: `/ococ/datacapture/v1/openmarket/v1/kmc/${reqData.serverName}`,
        method: 'get'
    })
}

export function getKmcDetailDecrypt(reqData) {
    return request({
        url: `/ococ/datacapture/v1/openmarket/v1/kmc/${reqData.rec_cert}/${reqData.certNum}`,
        method: 'get'
    })
}


export function getAfterActivationDetailEncrypt(serverName) {
    return request({
        url: `/ococ/activation/v1/afterActivation/${serverName}`,
        method: 'get'
    })
}

export function getAfterActivationDetailDecrypt(rec_cert,certNum) {
    return request({
        url: `/ococ/activation/v1/afterActivation/${rec_cert}/${certNum}`,
        method: 'get'
    })
}

export function savePublAutnInfo(reqData) {
    return request({
        url: `/ococ/datacapture/v1/autn/publ`,
        method: 'post',
        data: reqData
    })
}

export function saveMobileAutnInfo(reqData) {
    return request({
        url: `/ococ/datacapture/v1/autn/mobile`,
        method: 'post',
        data: reqData
    })
}

export function saveMobileAuthInfo(reqData) {
    return request({
        url: `/ococ/datacapture/auth/saveMobileAuthInfo`,
        method: 'post',
        data: reqData
    })
}

export function saveKmcAuthInfo(reqData) {
    return request({
        url: `/ococ/datacapture/v1/autn/kmc`,
        method: 'post',
        data: reqData
    })
}

// IPIN 인증 모듈
export function getIpinEncrypt(reqData) {
    return request({
        url: `/ococ/datacapture/v1/openmarket/v1/getIpinEncrypt/${reqData.serverName}`,
        method: 'get'
    })
}

export function getIpinDecrypt(reqData) {
    return request({
        url: `/ococ/datacapture/v1/openmarket/v1/getIpinDecrypt`,
        method: 'get',
        headers: {
            encodeData: reqData.encData
        }
    })
}

export function saveIpinData(reqData) {
    return request({
        url: `/ococ/datacapture/v1/ipinSave`,
        method: 'post',
        data: reqData
    })
}

// 카드 및 출금 계좌 인증
export function validAccount(reqData) {
    let params = {
        acntOwnrNo: reqData.acntOwnrNo,
        pymCustNm: reqData.pymCustNm,
        bankCd: reqData.bankCd,
        pymMthdCd: reqData.pymMthdCd,
        appfNo:reqData.appfNo

    }
    // 카드 유효기간 세팅
    if (reqData.cardValdEndYymm) {
        params.cardValdEndYymm = reqData.cardValdEndYymm
    }
    return request({
        url: `/ococ/datacapture/auth/getPymInfoVaildation`,
        method: 'get',
        headers: {
            // 계좌 및 카드 번호는 암호화하여 보내준다.
            bankAcntNo: window.btoa(reqData.bankAcntNo)
        },
        params
    })
}

// 이메일 검증
export function getBlEmailBlock(billEmailAddr) {
    const header = {
        billEmailAddr: window.btoa(billEmailAddr)
    }
    return request({
        url: `/ococ/datacapture/auth/emailBlock`,
        method: 'get',
        headers: header
    })
}

//홈TPS
export function getKMCDetailEncrypt(cpId) {
    return request({
        url: `/ococ/datacapture/v1/openmarket/v1/common/kmc/${cpId}`,
        method: 'get'
    })
}

//홈TPS
export function getKMCDetailDecryptTPS(reqData) {
    return request({
        url: `/ococ/datacapture/v1/openmarket/v1/common/kmc/${reqData.rec_cert}/${reqData.certNum}`,
        method: 'get'
    })
}

//홈TPS
export function callKMCAuthPopup(){
    return new Promise((resolve,reject)=>{
        
        window.cbAuthPop = (res) =>{
            resolve(res)
        }
        let url = '/onsaleHome/auth-popup'
        window.open(url,"_blank","width=450,height=550,top=100,left=100,fullscreen=no,menubar=no,status=no,toolbar=no,titlebar=yes,location=no,scrollbar=no")
    })

}


// tps 사용
export function callIpinPopupTPS() {
    return new Promise((resolve,reject)=>{
        window.cbAuthPop = (res) =>{
            resolve(res)
        }

        let url = '/auth-popup/ipin-auth-popup'
        window.open(url,"authPopup","width=450,height=550,top=100,left=100,fullscreen=no,menubar=no,status=no,toolbar=no,titlebar=yes,location=no,scrollbar=no")


    })
}

// 모바일 인증
export function smsAuthSendTPS(reqData) {
    let mobileInfo = {
        phoneNo: reqData.phoneNo,
        dealCd: reqData.dealCd,
        onetMblAppfNo: reqData.onetMblAppfNo,
        buyer: reqData.lgdBuyer,
        birthDay: reqData.lgdPrivateno
    }
    return request({
        url: `/ococ/datacapture/auth/smsAuthSendTPS`,
        method: 'post',
        data: mobileInfo
    })
}

// 홈 TPS SMS 인증 결과체크 페이지
export function smsAuthCheckTPS(reqData) {
    let mobileAuthInfo =  {
        no: reqData.phoneNo,
        dealCd: reqData.dealCd,
        onetMblAppfNo: reqData.onetMblAppfNo,
        custName: reqData.lgdBuyer,
        juminNo: reqData.lgdPrivateno,
        smsval: reqData.smsval,
        tradeid: reqData.tradeid,
        isDomestic : reqData.isDomestic,
        sex : reqData.sex

    }
    return request({
        url: `/ococ/datacapture/auth/smsAuthCheckTPS`,
        method: 'post',
        data: mobileAuthInfo
    })
}


//광명시도명목록조회(5G커버리지)
export function searchCtdoClssNmList() {

    return request({
        url: '/ococ/datacapture/v1/ctdoClssNmList',
        method: 'get'
    })
}

//시군구명목록조회(5G커버리지)
export function searchCcwNmList(ctdoClssNm) {
    let params = {
        iSd: ctdoClssNm
    }
    return request({
        url: '/ococ/datacapture/v1/ccwNmList',
        method: 'get',
        params
    })
}

//읍면동명목록조회(행정동)(5G커버리지)
export function searchTownNmAdngList(addr) {
    let params = {
        iSd: addr.ctdoClssNm,
        iSgg:addr.ccwNm
    }
    return request({
        url: '/ococ/datacapture/v1/townNmAdngList',
        method: 'get',
        params
    })
}

// 홈 TPS CI 검증
export function getTpsAutnInfo(reqData) {
    const header = {
        ciNo: encodeURIComponent(reqData.ipinCi),
        custName: window.btoa(encodeURIComponent(reqData.moct_name)),
        juminNo: reqData.moct_birthDay  ,
        no: reqData.moct_phoneNo
    }
    return request({
        url: `/ococ/datacapture/v1/autn/getTpsAutnCheck`,
        method: 'get',
        headers: header
    })
}

// 홈 TPS CI 검증
/*export function getTpsAutnInfo(reqData) {
    const header = {
        ciNo: encodeURIComponent(reqData.ipinCi),
    }
    return request({
        url: `/ococ/datacapture/v1/autn/getTpsAutnInfo`,
        method: 'get',
        headers: header
    })
}*/